export default __webpack_public_path__ + "static/media/stitching_frame_white.8de69ff9.svg";